import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';

import styles from './styles';

export default function Wrapper({
  children,
  invalid = false,
  error = false,
}: {
  children: ReactNode;
  invalid?: boolean;
  error?: boolean;
}) {
  return (
    <Stack
      sx={{
        ...styles.wrapper,
        ...(invalid || error ? { borderColor: '#FF5252' } : {}),
        ...(error ? { backgroundColor: '#FFFBFA' } : {}),
      }}
      direction="row"
      gap="12px"
    >
      {children}
    </Stack>
  );
}
